module.exports = __webpack_public_path__ + "img/green-sea-turtle.b01f867d.jpg";